import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FlexboxGapStack from './FlexboxGapStack';
import ClientProvider from './client';
export default createDemo(import.meta.url, FlexboxGapStack, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/stack/demos/flexbox-gap/FlexboxGapStack.tsx",
    "fileName": "FlexboxGapStack.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Paper from '@mui/material/Paper';\nimport Stack from '@mui/material/Stack';\nimport Box from '@mui/material/Box';\nimport { styled } from '@mui/material/styles';\n\nconst Item = styled(Paper)(({ theme }) => ({\n  backgroundColor: '#fff',\n  ...theme.typography.body2,\n  padding: theme.spacing(1),\n  textAlign: 'center',\n  color: (theme.vars ?? theme).palette.text.secondary,\n  flexGrow: 1,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n  }),\n}));\n\nexport default function FlexboxGapStack() {\n  return (\n    <Box sx={{ width: 200 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Stack\n        spacing={{ xs: 1, sm: 2 }}\n        direction=\"row\"\n        useFlexGap\n        sx={{ flexWrap: 'wrap' }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Long content</Item>\n      </Stack>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 33,
        "focusedLines": 10,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Paper from '@mui/material/Paper';\nimport Stack from '@mui/material/Stack';\nimport Box from '@mui/material/Box';\nimport { styled } from '@mui/material/styles';\n\nconst Item = styled(Paper)(({ theme }) => ({\n  backgroundColor: '#fff',\n  ...theme.typography.body2,\n  padding: theme.spacing(1),\n  textAlign: 'center',\n  color: (theme.vars ?? theme).palette.text.secondary,\n  flexGrow: 1,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n  }),\n}));\n\nexport default function FlexboxGapStack() {\n  return (\n    <Box sx={{ width: 200 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Stack\n        spacing={{ xs: 1, sm: 2 }}\n        direction=\"row\"\n        useFlexGap\n        sx={{ flexWrap: 'wrap' }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Long content</Item>\n      </Stack>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Stack"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "spacing"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "xs"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "sm"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "2"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "direction"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "row",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "useFlexGap"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "flexWrap"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "wrap",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            "      >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">Item 1</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">Item 2</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">Long content</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Stack"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 33,
    "focusedLines": 10,
    "collapsible": true,
    "externals": [
      "@mui/material/Paper",
      "@mui/material/Stack",
      "@mui/material/Box",
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
